import { claimSchema } from "schemas";
import { z } from "zod";
import { apiClient } from "../client";

export const getClaims = async () =>
  z.array(claimSchema).parse((await apiClient.get("v1/claims")).data.claims);
